import { mapActions, mapGetters } from 'vuex'
import { SnackbarStyle } from '@/constants/constants'
import authApi from '@/api/auth.api'
import i18n from '@/i18n'
import { RESET_PASSWORD_TYPES } from '@colven/common-domain-lib/lib'

export default {
  name: 'ResetPasswordComponent',
  data () {
    return {
      username: '',
      newPassword: '',
      repeatNewPassword: '',
      jwtQuery: '',
      resetPasswordType: RESET_PASSWORD_TYPES.USER_RESET,
      decodedJwt: {},
      submitted: false,
      showNewPassword: false,
      showRepeatNewPassword: false,
      validForm: false,
      rules: {
        required: value => !!value || `${i18n.t('required')}`,
        min: (value, minValue) => value.length >= minValue || `${i18n.t('min', { min: minValue })}`,
        samePassword: (password, repeatPassword) => password === repeatPassword || `${i18n.t('resetPassword.notEqualsRepeatPassword')}`,
        notUsername: (password, username) => {
          const searchText = username.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
          return ((password.match(new RegExp(searchText, 'i')) == null) || `${i18n.t('resetPassword.containsUsername')}`)
        }
      }
    }
  },
  mounted () {
    this.jwtQuery = this.$route.params.token
    this.resetPasswordType = this.$route.meta.type
    if (!this.getResetPasswordJWT) {
      this.setResetPasswordJWT(this.jwtQuery)
    }
    // this.username = VueJwtDecode.decode(this.jwtQuery).username
    authApi.validateResetPasswordToken(this.jwtQuery).then(validationResponse => {
      this.username = validationResponse.data.username
    }).catch(() => {
      setTimeout(() => {
        this.$router.push('/login').catch(err => {
          console.log(err)
        })
      }, 6000)
    })
  },
  computed: {
    ...mapGetters({
      'getResetPasswordJWT': 'user/getResetPasswordJWT'
    }),
    formTitleLabel () {
      switch (this.resetPasswordType) {
        case RESET_PASSWORD_TYPES.USER_RESET:
          return this.$t('resetPassword.userReset')
        case RESET_PASSWORD_TYPES.NEXT_LOGIN:
          return this.$t('resetPassword.nextLogin')
        case RESET_PASSWORD_TYPES.EXPIRATION:
          return this.$t('resetPassword.expiration')
        default:
          return this.$t('resetPassword.userReset')
      }
    }
  },
  methods: {
    ...mapActions({
      'showSnackbar': 'snackbar/showSnackbar',
      'closeSnackbar': 'snackbar/closeSnackbar',
      'setResetPasswordJWT': 'user/setResetPasswordJWT',
    }),
    async submit () {
      this.submitted = true
      const body = { username: '', password: '', repeatPassword: '', resetPasswordType: '' }
      body.username = this.username
      body.password = this.newPassword
      body.repeatPassword = this.repeatNewPassword
      body.resetPasswordType = this.resetPasswordType
      authApi.resetPassword(body).then(() => {
        this.showSnackbar({ visible: true, text: this.$t('resetPassword.successfulPasswordReset'), timeout: 6000, style: SnackbarStyle.SUCCESS })
        setTimeout(() => {
          this.$router.push('/login').catch(err => {
            console.log(err)
          })
        }, 6000)
      }).catch(() => {
        this.submitted = false
      })
    }
  }
}
